/* tslint:disable */
/* eslint-disable */
/**
 * mindd-scanmini-api-server
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import type { AnalysisSummary } from './analysis-summary';
// May contain unused imports in some cases
// @ts-ignore
import type { UsageTime } from './usage-time';

/**
 * Prescription DTO
 * @export
 * @interface Prescription
 */
export interface Prescription {
    /**
     * ID
     * @type {string}
     * @memberof Prescription
     */
    'id'?: string;
    /**
     * 병원(기관) ID
     * @type {number}
     * @memberof Prescription
     */
    'orgId'?: number;
    /**
     * 환자 ID(subjectId)
     * @type {string}
     * @memberof Prescription
     */
    'patientId'?: string;
    /**
     * 측정 횟수
     * @type {number}
     * @memberof Prescription
     */
    'measurementCount'?: number;
    /**
     * 센서 타입
     * @type {string}
     * @memberof Prescription
     */
    'sensorType'?: PrescriptionSensorTypeEnum;
    /**
     * 디바이스 시리얼(Full Serial Code)
     * @type {string}
     * @memberof Prescription
     */
    'deviceBarcode'?: string;
    /**
     * 디바이스 ID(devicehiber id)
     * @type {number}
     * @memberof Prescription
     */
    'deviceId'?: number;
    /**
     * Round별 사용 시간 기록
     * @type {Array<UsageTime>}
     * @memberof Prescription
     */
    'usageTimes'?: Array<UsageTime>;
    /**
     * 분석 요약
     * @type {AnalysisSummary}
     * @memberof Prescription
     */
    'analysisSummary'?: AnalysisSummary;
    /**
     * 생성 시간
     * @type {string}
     * @memberof Prescription
     */
    'createdAt'?: string;
    /**
     * 취소된 시간
     * @type {string}
     * @memberof Prescription
     */
    'canceledAt'?: string;
    /**
     * 삭제된 시간
     * @type {string}
     * @memberof Prescription
     */
    'deletedAt'?: string;
    /**
     * 회수 실패 시간
     * @type {string}
     * @memberof Prescription
     */
    'recoveryFailedAt'?: string;
    /**
     * 회수 실패 사유
     * @type {string}
     * @memberof Prescription
     */
    'recoveryFailureReason'?: string;
    /**
     * 처방 상태
     * @type {string}
     * @memberof Prescription
     */
    'status'?: PrescriptionStatusEnum;
}

export const PrescriptionSensorTypeEnum = {
    Eeg: 'EEG',
    Ecg: 'ECG'
} as const;

export type PrescriptionSensorTypeEnum = typeof PrescriptionSensorTypeEnum[keyof typeof PrescriptionSensorTypeEnum];
export const PrescriptionStatusEnum = {
    Waiting: 'WAITING',
    InProgress: 'IN_PROGRESS',
    Completed: 'COMPLETED',
    AnalysisFailed: 'ANALYSIS_FAILED',
    Cancelled: 'CANCELLED',
    AnalysisUnavailable: 'ANALYSIS_UNAVAILABLE'
} as const;

export type PrescriptionStatusEnum = typeof PrescriptionStatusEnum[keyof typeof PrescriptionStatusEnum];


